import React, { createContext, useContext, useState } from 'react';

const UIContext = createContext();

export const useUIContext = () => {
    return useContext(UIContext);
};

export const UIProvider = ({ children }) => {
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

    const toggleMobileSidebar = () => {
        setIsMobileSidebarOpen(!isMobileSidebarOpen);
    };

    const closeMobileSidebar = () => {
        setIsMobileSidebarOpen(false);
    };

    const value = {
        isMobileSidebarOpen,
        toggleMobileSidebar,
        closeMobileSidebar
    };

    return (
        <UIContext.Provider value={value}>
            {children}
        </UIContext.Provider>
    );
};
